import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
  UpdateNotificationDTO,
  UserApiService,
} from 'features/users/api/user-api.service';

import { userQueryKeys } from './query-keys';

const { readallNotification } = UserApiService();

export const ReadallNotification = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: UpdateNotificationDTO) => {
      return readallNotification(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: userQueryKeys.lists(),
        });
        message.success('Notification clear');
      },
    },
  );
};
